import {
  GoToOTPVerificationEvent,
  SendFrontendSegmentEvent,
  SendGAEvent
} from '../../../product';

import { formsMachineEvents } from '../../constants/formMachineConstants';
import { FormsMachineEvent } from '../../machines/PublicFormsMachine/types';

export const getEventDetailsFromEventName = (
  eventName: string,
  formValues?: Record<string, any>
): FormsMachineEvent => {
  if (eventName === formsMachineEvents.goToOtpVerificationStep) {
    return {
      type: formsMachineEvents.goToOtpVerificationStep,
      values: {
        phoneNumber: formValues?.['phone']
      }
    } as GoToOTPVerificationEvent;
  } else if (eventName.includes('SEND_GA_EVENT')) {
    const event = {
      type: 'SEND_GA_EVENT',
      eventName: eventName.replace('SEND_GA_EVENT_', '')
    } as SendGAEvent;
    return event;
  } else if (eventName.includes('SEND_FRONTEND_SEGMENT_EVENT')) {
    const event = {
      type: 'SEND_FRONTEND_SEGMENT_EVENT',
      eventName: eventName.replace('SEND_FRONTEND_SEGMENT_EVENT_', '')
    } as SendFrontendSegmentEvent;
    return event;
  } else {
    return { type: eventName } as FormsMachineEvent;
  }
};
